import styled from 'styled-components';

export const Wrapper = styled.div`
  padding: 16px;
  border-radius: 16px;
  background: #edf0f5;
  display: flex;
  width: 50%;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  cursor: pointer;

  ${({ disabled }) =>
    disabled &&
    `
    cursor: default;

    p,svg {
      opacity: 0.4;
    }
    
  `}

  .progress-bar {
    width: 40px;
    height: 40px;

    .CircularProgressbar-text {
      fill: #000;
    }
    .CircularProgressbar-path {
      stroke: #495bd1;
    }
    /* .CircularProgressbar-trail {
      stroke: #495bd1;
    } */
  }

  p {
    color: #5c5d61;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
  }
`;
